import { useState } from 'react';
import { ValidationResult } from './validators';

type FieldData = {
  visibleName: string,
  required?: boolean,
  requiredIf?: (value: string | undefined) => boolean,
  validations?: Array<((value: string) => ValidationResult)>
  type?: 'text' | 'boolean'
}

export type FieldState = FieldData & {
  value: string | undefined,
  setValue: (value: string | undefined) => void,
  setBoolean: (value: boolean) => void,
  getBoolean: () => boolean,
  error: string | undefined,
  setError: (value: string | undefined) => void
}

export type FormData = Record<string, FieldData>;
export type FormState = Record<string, FieldState>;

export const useForm = (fields: FormData): FormState => {
  // TODO: refactor this function
  const obj: FormState = {};

  for (const fieldName in fields) {
    const field = fields[fieldName];
    if (!field.type) field.type = 'text';
    const [value, setValueImpl] = useState<string | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const getBoolean = () => value === 'true';
    const fieldOperations: Partial<FieldState> = { ...field, value, error, setError, getBoolean };
    let setValue: (value: string | undefined) => void;
    if (field.type === 'boolean') {
      setValue = (value: string | undefined) => {
        if (typeof value === 'undefined') {
          setValueImpl(undefined);
          return;
        }
        if (value.toLowerCase() === 'false' || value.length === 0) {
          setValueImpl('false');
        } else if (value.toLowerCase() === 'true') {
          setValueImpl('true');
        } else {
          throw new Error(`${fields[fieldName]} is boolean, must be set to 'true' or 'false'`);
        }
      };
    } else {
      setValue = setValueImpl;
    }
    fieldOperations.setBoolean = (value: boolean | undefined) => (
      setValue(typeof value === 'undefined' ? undefined : value.toString())
    );
    fieldOperations.setValue = setValue;

    obj[fieldName] = fieldOperations as FieldState;
  }

  return obj;
};

export const resetForm = (form: FormState) => {
  Object.values(form).forEach(field => field.setValue(undefined));
};
